import React from 'react';
import { TopBar, StickyCTA, PurchaseNotifications } from '../components/Layout';
import { Hero, Tension, WhatThisIs, MainCollection } from '../components/Sections';
import { Volumes, Bonuses, Benefits, PostPurchase } from '../components/ContentSections';
import { Pricing, Guarantee, FAQ, FinalCTA } from '../components/ConversionSections';
export function LandingPage() {
  return <div className="min-h-screen bg-brand-dark flex flex-col font-sans selection:bg-brand-gold selection:text-brand-dark" data-id="element-192">
      <TopBar data-id="element-193" />

      <main className="flex-1" data-id="element-194">
        <Hero data-id="element-195" />
        <Tension data-id="element-196" />
        <WhatThisIs data-id="element-197" />
        <MainCollection data-id="element-198" />
        <Volumes data-id="element-199" />
        <Bonuses data-id="element-200" />
        <Benefits data-id="element-201" />
        <PostPurchase data-id="element-202" />
        <Pricing data-id="element-203" />
        <Guarantee data-id="element-204" />
        <FAQ data-id="element-205" />
        <FinalCTA data-id="element-206" />
      </main>

      <footer className="bg-brand-anthracite py-8 border-t border-brand-card text-center px-5" data-id="element-207">
        <p className="text-brand-muted text-xs" data-id="element-208">
          &copy; {new Date().getFullYear()} Colección Nos Mienten. Todos los
          derechos reservados.
        </p>
      </footer>

      <StickyCTA data-id="element-209" />
      <PurchaseNotifications data-id="element-210" />
    </div>;
}